import React from "react";
import { GlobalBox } from "components/Box/GlobalBox";
import { useDispatch, useSelector } from "react-redux";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { TableInputs } from "components/CardTable/TableInputs";
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportDiscountsRelationshipFilters, getReportDiscountsRelationshipAction } from "redux/actions/Reports/reportDiscountsRelationship/reportDiscountsRelationshipActions";
import { useSearch } from "hooks/useSearch";

export const ReportDiscountsRelationshipView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(state => state.reportDiscountsRelationship);

  const handleSubmit = (e, isPdf = true) => {
    e.preventDefault();
    if (!station?.id) {
      setSnackbar("Falta seleccionar planta.", 'warning');
      return;
    }
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    dispatch(getReportDiscountsRelationshipAction({ startDate, endDate, station, isPdf }));
  };

  return (
    <GlobalBox title="Reporte Relación de Descuento" icon={<AssessmentIcon />}>
      {isLoadingComp?.loadingDiscountsRelationship
        ? <LoadingComponent />
        : <TableInputs
            reducer="reportDiscountsRelationship"
            dates
            stations
            maxDate={newDate()}
            dispatchAction={setReportDiscountsRelationshipFilters}
            submitAction={handleSubmit}
            submitSecond={(e) => handleSubmit(e, false)}
            submitButtonName="PDF"
          />
      }
    </GlobalBox>
  );
};
